import React from "react";
import { Row, Col, Button } from "antd";
import { useHistory } from "react-router-dom";
import Footer from "../components/section/Footer";

const Page = () => {
  const history = useHistory();

  return (
    <section
      style={{
        overflowX: "hidden",
        height: "100vh",
      }}
    >
      <div
        style={{
          zIndex: 1,
          paddingTop: 24,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <div
          style={{
            marginBottom: 16,
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/Logo.png`} alt="Logo" />
        </div>
        <div
          className="text-header"
          style={{
            width: "60%",
            margin: "auto",
          }}
        >
          BADAN LITBANG DAN DIKLAT KEMENTERIAN AGAMA
          <br />
          KEMENTERIAN AGAMA REPUBLIK INDONESIA
        </div>
        <div className="text-default">
          SIPENDA
          <br />
          (SISTEM INFORMASI PENDIDIKAN AGAMA DAN KEAGAMAAN)
        </div>
      </div>
      <div
        style={{
          display: "flex",
          zIndex: 1,
          justifyContent: "center",
          margin: "12px 0px 32px 0px",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/main-image.png`}
          alt="Main Page Illustration"
          style={{
            width: 600,
          }}
        />
      </div>
      <Row
        style={{
          minHeight: 360,
        }}
        justify="center"
        align="top"
      >
        <Col>
          <div className="text-header">
            Halaman ini sedang dalam masa pengembangan
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              size="large"
              shape="round"
              style={{
                backgroundColor: "#1B6FBA",
                color: "#fff",
              }}
              onClick={() => {
                history.push("/");
              }}
            >
              Kembali ke Halaman Utama
            </Button>
          </div>
        </Col>
      </Row>
      <Footer />
      <img
        src={`${process.env.PUBLIC_URL}/assets/bg-main.png`}
        alt="Background"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
        }}
      />
    </section>
  );
};

export default Page;
